import default_logo from 'assets/images/LogoMevakerMobile.png';
import { setPeriod } from "../redux/generalReducer";
import { store } from "../redux/store";
import { DefaultLogoType } from 'hooks/useImage';
import { FirstCategoryEnum, MonthEnum } from 'enums/enums';

export const formatDate = () => {
    const date = currentDate;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const currentDate = new Date();
export const currentYear = currentDate.getFullYear();
export const currentMonth = currentDate.getMonth() + 1;
export const isJanuary = currentMonth == MonthEnum.January;
export const defaultYear = () => ({
    text: (isJanuary ? (currentYear - 1) : currentYear).toString(),
    indexes: isJanuary ? [1] : [0],
});
store.dispatch(setPeriod({ ...store.getState().general.period, year: defaultYear() }))

export const toIntSafe = (value) => value ? parseInt(value, 10) : null;
export const toJsonSafe = (value) => value ? JSON.parse(value) : null;

export const loadLogo = async (companyId: string, defaultLogo: DefaultLogoType) => {
    const possibleExtensions = ['png','PNG', 'gif']; // Add more extensions as needed

    for (const ext of possibleExtensions) {
        try {
            const logo = await import(`../assets/logos/${companyId}.${ext}`);
            return logo.default as Promise<string>;
        } catch (error) {
            continue;
        }
    }
    if (!defaultLogo) {
        const logo = await import(`../assets/logos/DefaultLogoInstitutes.png`);
        return logo.default;
    }
    const png = await import(`../assets/logos/DefaultLogo${defaultLogo}.png`);
    return png.default;
}

export const NUM_OF_ROWS_FOR_TABLE = 15
export const COMPLAINTS_LIMIT = 5;

export const getCategoryFilters = () => { return Object.values(FirstCategoryEnum) };

export const numberWithCommas = (number: number) => {
    return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const relativeNumber = '10,000';

export const pluginsDefinitions = (isContrast: boolean) => {
    return {
        legend: {
            rtl: true,
            display: true,
            position: 'bottom',
            align: 'start',
            labels: {
                usePointStyle: true,
                color: isContrast ? 'white' : 'gray',
            }
        },
    }
}